export default {
  xsmall: '4px',
  small: '8px',
  medium: '16px',
  large: '20px',
  xlarge: '24px',
  xxlarge: '32px',
  xxxlarge: '40px',
  xxxxlarge: '48px',
};
